import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import paneheader from "../../../../assets/images/docs/paneheader.png";
import panefooter from "../../../../assets/images/docs/panebottom.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  paneheader,
  panefooter,
  React
};